import { message } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { TRootState } from '../../store/store';
import { resetBalanceById } from '../../store/wallet/wallet.slice';
import { transport } from '../../utils/constants';
import { getToken, isRpcError, Notification, type } from '../../utils/helper';
import ControlledInput from '../Common/ControlledInput/ControlledInput';
import IosModal from '../Common/IosModal/IosModal';
import Search from '../Common/Search/Search';
import ShortProfile from '../Common/ShortProfile/ShortProfile';
import './Transfer.scss';
import { WalletClient } from '../../generated/mlmbox/client/finance/wallet.client';
import { Status_Transaction } from '../../generated/mlmbox/types/status';
import { Account_Info } from '../../generated/mlmbox/types/account';
import Button from '../Button/Button';

const Transfer: React.FC<{
    assetId: number;
    closeBtn: Function;
    setReload: Function;
}> = ({ assetId, closeBtn, setReload }) => {
    const wallet = useSelector((state: TRootState) => state.wallet.value);
    const [amountValue, setAmountValue] = useState('');
    const [toUser, setToUser] = useState<Account_Info | null>(null);
    const [userProfile, setUserProfile] = useState<Account_Info | null>(null);
    const [openAmount, setOpenAmount] = useState(false);
    const [openToUser, setOpenToUser] = useState(false);
    const [close, setClose] = useState(false);
    const dispatch = useDispatch();
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const { t } = useTranslation();
    const walletClient = new WalletClient(transport);

    function transfer() {
        if (!toUser?.account?.id || amountValue.length === 0) return;

        walletClient
            .transfer(
                {
                    account: { uniqueField: { accountId: toUser?.account?.id, oneofKind: 'accountId' } },
                    operationAmount: {
                        assetId,
                        value: amountValue,
                    },
                },
                { meta: { authorization: getToken() } }
            )
            .then(({ status, response }) => {
                if (status.code === 'OK' && response.statusId === Status_Transaction.SUCCESS) {
                    dispatch(resetBalanceById({ assetId, balance: response.balance }));
                    setReload((prev: boolean) => !prev);
                    closing();
                    Notification(type.success);
                    message.success(t('wallet.transfer.success'));
                }
            })
            .catch((err) => {
                if (isRpcError(err)) {
                    if (err.code === '7') {
                        Notification(type.error);
                        message.error(t('errors.not_operation'));
                    }
                    if (err.code === '5') {
                        Notification(type.error);
                        message.error(t('errors.user_not_found'));
                    }
                    if (err.code === '3') {
                        Notification(type.error);
                        message.error(t('errors.login_format'));
                    }
                }
            });
    }

    function closing() {
        setClose(true);
        setTimeout(() => closeBtn(), 200);
    }

    function validateAmount(amount: string): boolean {
        let result;

        if (Number(amount) > Number(wallet.assets[assetId - 1].assetBalance)) {
            setErrorMessage(t('errors.money_small', { dop: '' }));
            Notification(type.error);
            return (result = false);
        }

        if (Number(amount) < Number(wallet.assets[assetId - 1].settingsTransferLimitMin)) {
            setErrorMessage(t('errors.lim_transfer', { amount: Number(wallet.assets[assetId - 1].settingsTransferLimitMin).toLocaleString() }));
            Notification(type.error);
            return (result = false);
        }

        result = true;

        return result;
    }

    useEffect(() => {
        if (errorMessage) {
            setTimeout(() => {
                setErrorMessage(null);
            }, 3200);
        }
    }, [errorMessage]);

    return (
        <>
            <div className="transfer">
                <div
                    className="out"
                    onClick={closing}></div>
                <div
                    className="transfer__dialog"
                    id={close ? 'close' : ''}>
                    {closeBtn && (
                        <span
                            className="transfer__dialog--close-btn"
                            onClick={closing}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="8"
                                viewBox="0 0 12 8"
                                fill="none">
                                <path
                                    d="M6.01744 7.39803C5.91269 7.39852 5.8089 7.37809 5.71215 7.33793C5.61541 7.29778 5.52766 7.2387 5.45405 7.16417L0.139066 1.84919C0.0330583 1.6941 -0.0147788 1.50656 0.00399088 1.31964C0.0227606 1.13273 0.106932 0.958441 0.241659 0.827527C0.376386 0.696613 0.553015 0.617479 0.740393 0.604082C0.92777 0.590685 1.11386 0.643885 1.26584 0.754301L6.01744 5.47401L10.769 0.754301C10.9189 0.657152 11.097 0.613122 11.2748 0.629266C11.4527 0.645411 11.6199 0.720795 11.7498 0.843336C11.8797 0.965878 11.9647 1.12848 11.9912 1.30508C12.0177 1.48168 11.9841 1.66206 11.8958 1.8173L6.58083 7.13228C6.50996 7.2126 6.42344 7.2776 6.32656 7.3233C6.22968 7.369 6.12449 7.39443 6.01744 7.39803Z"
                                    fill="#506690"
                                />
                            </svg>
                        </span>
                    )}
                    <div className="transfer__dialog--content">
                        <h1>{t('wallet.transfer.title') + ' ' + (assetId === 1 ? 'USDT' : 'MELLSTROY')}</h1>
                        <div className="transfer__dialog--content--form">
                            <label>
                                {t('wallet.transfer.labeles.sum')}
                                <div
                                    className="input"
                                    onClick={() => setOpenAmount(true)}>
                                    {amountValue}
                                </div>
                            </label>
                            <label>
                                {t('wallet.transfer.labeles.to')}
                                <div
                                    className="input"
                                    onClick={() => {
                                        // setToUser(null);
                                        setOpenToUser(true);
                                    }}>
                                    {toUser?.account?.id ? 'id' + toUser?.account?.id : ''}
                                </div>
                            </label>
                        </div>
                        <div className="transfer__dialog--content--btns">
                            <Button
                                onClick={closing}
                                title={t('wallet.transfer.btns.cancel')}
                            />
                            <Button
                                onClick={() => {
                                    if (!amountValue || !toUser || Number(amountValue) > Number(wallet.assets[assetId - 1].assetBalance)) return;
                                    transfer();
                                }}
                                disabled={!amountValue || !toUser || Number(amountValue) > Number(wallet.assets[assetId - 1].assetBalance)}
                                title={t('wallet.btns.transfer')}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {openAmount && (
                <ControlledInput
                    close={() => setOpenAmount(false)}
                    setValue={setAmountValue}
                    placeholder={t('placeholders.transfer_sum')}
                    title={t('modals.ios.header.titles.transfer')}
                    typeInput="number"
                    value={amountValue}
                    errorMessgae={errorMessage}
                    validate={validateAmount}>
                    <ul className="description">
                        {errorMessage && (
                            <li
                                style={{ margin: '-5px 0 12px 0' }}
                                className="danger">
                                {errorMessage}
                            </li>
                        )}
                    </ul>
                </ControlledInput>
            )}
            {openToUser && (
                <IosModal
                    cancel={() => setOpenToUser(false)}
                    cancelBtnTitle={t('modals.ios.header.btns.cancel')}
                    backButtonTitle={userProfile ? t('modals.ios.header.btns.back') : ''}
                    backButton={() => setUserProfile(null)}
                    aproveBtnTitle={userProfile ? t('modals.ios.header.btns.confirm') : ''}
                    title={t('modals.ios.header.titles.user_login')}
                    aprove={() => {
                        if (userProfile) {
                            setToUser(userProfile);
                            setOpenToUser(false);
                            setUserProfile(null);
                        }
                    }}>
                    {userProfile ? (
                        <ShortProfile {...userProfile} />
                    ) : (
                        <Search
                            placeholder={t('placeholders.login_to')}
                            setSelect={setUserProfile}
                        />
                    )}
                </IosModal>
            )}
        </>
    );
};

export default Transfer;
